// src/react/context.ts
import {
  createContext,
  useMemo,
  useContext,
  useState,
  useEffect,
  createElement
} from "react";

// src/flagr.gen.ts
import * as Oazapfts from "oazapfts/lib/runtime";
import * as QS from "oazapfts/lib/runtime/query";
var defaults = {
  baseUrl: "/"
};
var oazapfts = Oazapfts.runtime(defaults);
function postEvaluation(evalContext, opts) {
  return oazapfts.fetchJson("/api/v1/evaluation", oazapfts.json({
    ...opts,
    method: "POST",
    body: evalContext
  }));
}

// src/react/context.ts
import { ok } from "oazapfts";
function createContextWithSelector(initialValue = null) {
  const context = createContext(initialValue);
  const { Provider } = context;
  const useSelector2 = function(f) {
    const _context = useContext(context);
    if (_context === null) {
      throw new Error("Provider not configure");
    } else {
      const value = f(_context);
      return useMemo(() => value, [value]);
    }
  };
  return {
    Provider,
    useSelector: useSelector2
  };
}
var loaded = (id, data) => ({
  type: "loaded",
  data,
  id
});
var error = (id, retry, error2) => ({
  type: "error",
  error: error2,
  id,
  retry
});
var isLoaded = (i) => i.type === "loaded";
var isError = (i) => i.type === "error";
var onlyLoaded = (items) => items.filter(isLoaded);
var onlyError = (items) => items.filter(isError);
var isEvalContext = (id) => id.flagID !== void 0;
var M = createContextWithSelector(null);
var useSelector = M.useSelector;
var FlagProvider = (props) => {
  const [state, setState] = useState({
    flagrIds: [],
    flag: () => {
    },
    retry: () => {
    }
  });
  const flag2 = (id) => {
    setState((prev) => {
      const hasListed = prev.flagrIds.find((f) => f.id === id);
      const flagrIds = prev.flagrIds.filter((f) => f.id !== id).concat(hasListed ? [hasListed] : [{ type: "idle", id }]);
      return {
        ...prev,
        flagrIds
      };
    });
  };
  const retry = (flagItem) => {
    const errorFlag = {
      ...flagItem,
      retry: flagItem.retry ? flagItem.retry + 1 : 1
    };
    const filteredFlag = state.flagrIds.filter((f) => f.id !== errorFlag.id);
    setState((prev) => ({
      ...prev,
      flagrIds: filteredFlag.concat(errorFlag)
    }));
  };
  useEffect(() => {
    Promise.all(
      state.flagrIds.filter((f) => ["idle", "refetch"].includes(f.type)).map(
        (flagId) => ok(
          postEvaluation(
            isEvalContext(flagId.id) ? flagId.id : { flagID: flagId.id },
            { baseUrl: props.flagUrl }
          )
        ).then((data) => loaded(flagId.id, data)).catch(
          (e) => error(flagId.id, flagId.type === "refetch" ? flagId.retry : 0, e)
        )
      )
    ).then((flagItems) => {
      const loadedItems = onlyLoaded(flagItems);
      if (loadedItems.length > 0) {
        setState((prev) => {
          const loadedIds = loadedItems.map((item) => item.id);
          const flagrIds = prev.flagrIds.filter((f) => !loadedIds.includes(f.id)).concat(loadedItems);
          return { ...prev, flagrIds };
        });
      }
      const errorItems = onlyError(flagItems);
      if (errorItems.length > 0) {
        setState((prev) => {
          const errorIds = errorItems.map((item) => item.id);
          const flagrIds = prev.flagrIds.filter((f) => !errorIds.includes(f.id)).concat(errorItems);
          return { ...prev, flagrIds };
        });
      }
    });
  }, [state.flagrIds]);
  const value = {
    flagrIds: state.flagrIds,
    flag: flag2,
    retry
  };
  return createElement(M.Provider, { value }, props.children);
};

// src/react/flag.tsx
import { useEffect as useEffect2 } from "react";
import { Fragment, jsx } from "react/jsx-runtime";
var Flag = ({ id, fallback, children }) => {
  const { flag: flag2, flagrIds } = useSelector(({ flag: flag3, flagrIds: flagrIds2 }) => ({ flag: flag3, flagrIds: flagrIds2 }));
  useEffect2(() => {
    flag2(id);
  }, []);
  const currentStateFlag = flagrIds.find((f) => f.type === "loaded" && f.data.flagID === id);
  const shouldRender = (currentStateFlag == null ? void 0 : currentStateFlag.type) === "loaded" && currentStateFlag.data.variantKey === "on";
  if (!shouldRender && fallback)
    return /* @__PURE__ */ jsx(Fragment, { children: fallback });
  return shouldRender ? /* @__PURE__ */ jsx(Fragment, { children }) : null;
};
function flag(id, val, fallback) {
  if (val === void 0 || val === null)
    return null;
  if (typeof id === "boolean") {
    if (typeof val === "boolean")
      return val;
    else
      return id ? val : fallback || false;
  }
  if (typeof id === "string" && typeof val === "string")
    return id ? val : fallback || "";
  if (typeof id === "number" && typeof val === "number")
    return id ? val : fallback || 0;
  if (typeof id === "function" && typeof val === "function")
    return id ? val : fallback || function() {
    };
  if (Array.isArray(id) && Array.isArray(val))
    return id ? val : fallback || null;
  if (fallback)
    return /* @__PURE__ */ jsx(Flag, { id, fallback, children: val });
  return /* @__PURE__ */ jsx(Flag, { id, children: val });
}
export {
  Flag,
  FlagProvider,
  flag,
  onlyError,
  onlyLoaded,
  useSelector
};
